// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { MarkdownPreview } from 'react-marked-markdown';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ text }) => (
  <div className='rte_viewer' style={{ whiteSpace: 'pre' }}>
    <MarkdownPreview markedOptions={{ breaks: true }} value={text} />
  </div>
);
